import { useCallback } from 'react';
import { useUserPreferences, useUserPreferencesMutation } from '@pm2/api';
import { GenderInput } from './atom.gender-input.js';
import { SpeedInput } from './atom.speed-input.js';
import { groupCls, itemCls, fieldsetCls, legendCls, desktopLegendCls, mobileLegendCls } from './speech-synthesis.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SpeechSynthesis() {
  const userPreferences = useUserPreferences();
  const userPreferencesMutation = useUserPreferencesMutation();
  const setSpeed = useCallback(speed => {
    userPreferencesMutation.mutate({
      ...userPreferences,
      speechSynthesis: {
        ...userPreferences.speechSynthesis,
        speed
      }
    });
  }, [userPreferences, userPreferencesMutation]);
  const setGender = useCallback(gender => {
    userPreferencesMutation.mutate({
      ...userPreferences,
      speechSynthesis: {
        ...userPreferences.speechSynthesis,
        gender
      }
    });
  }, [userPreferences, userPreferencesMutation]);
  return /*#__PURE__*/jsxs("ul", {
    className: groupCls,
    children: [/*#__PURE__*/jsx("li", {
      className: itemCls,
      children: /*#__PURE__*/jsxs("fieldset", {
        className: fieldsetCls,
        children: [/*#__PURE__*/jsxs("legend", {
          className: legendCls,
          children: [/*#__PURE__*/jsx("span", {
            className: desktopLegendCls,
            children: "Opl\xE6serhastighed"
          }), /*#__PURE__*/jsx("span", {
            className: mobileLegendCls,
            children: "Hastighed"
          })]
        }), /*#__PURE__*/jsx(SpeedInput, {
          steps: 5,
          activeSpeed: userPreferences.speechSynthesis.speed,
          onSpeedChange: setSpeed
        })]
      })
    }), /*#__PURE__*/jsx("li", {
      className: itemCls,
      children: /*#__PURE__*/jsxs("fieldset", {
        className: fieldsetCls,
        children: [/*#__PURE__*/jsxs("legend", {
          className: legendCls,
          children: [/*#__PURE__*/jsx("span", {
            className: desktopLegendCls,
            children: "Opl\xE6serstemme"
          }), /*#__PURE__*/jsx("span", {
            className: mobileLegendCls,
            children: "Stemme"
          })]
        }), /*#__PURE__*/jsx(GenderInput, {
          activeGender: userPreferences.speechSynthesis.gender,
          onGenderChange: setGender
        })]
      })
    })]
  });
}

export { SpeechSynthesis };
//# sourceMappingURL=speech-synthesis.js.map
